import Carousel from 'react-bootstrap/Carousel';

import HairMask from '../../Assets/Projects/HD/Castor-Oil-Hair-Mask.webp';

function CarouselFadeHairMask() {
  const customCarouselItemStyle = {
    display: 'flex',
    flexDirection: 'row', // Display in a row layout
    alignItems: 'center', // Center vertically
  };

  const customImageStyle = {
    marginRight: '10px', // Create some space between the image and caption
  };

  const customCaptionStyle = {
    flex: '1', // Take up remaining horizontal space

    borderBottomLeftRadius: '80px 80px',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    padding: '10px',
    marginLeft: '-50px',
    borderLeftRadius: '20rem', // Overlap the image slightly to the left
  };

  return (
    <Carousel fade controls={false} indicators={false}>
      <Carousel.Item style={customCarouselItemStyle}>
        <img
          src={HairMask}
          alt=""
          width={200}
          height={300}
          className="image-border-glow-bl-gold border-rounded p-2 m-2"
          style={customImageStyle}
          loading="lazy"
        />
        <div style={customCaptionStyle}>
          <h3>Castor Oil Hair Mask</h3>
          <p>
            Strength & rebuild & repair your hair Contains castor oil,relieve
            dryness and deeply hydrate both hair shafts and scalp.
          </p>
        </div>
      </Carousel.Item>
    </Carousel>
  );
}

export default CarouselFadeHairMask;
